export const APP_ROOT                      = "";

export const ROOT_ROUTE_PATIENTS           = "Patients";
export const ROUTE_PATIENT_PROFILE         = "PatientProfile";
export const ROUTE_PATIENT_PROFILE_PREVIEW = "PatientProfilePreview";
export const ROUTE_PATIENT_INFO            = "PatientInfo";
export const ROUTE_NEW_PATIENT             = "NewPatient";
export const ROUTE_EDIT_PATIENT            = "EditPatient";
export const ROUTE_NEW_PATIENT_CASE        = "NewPatientCase";
export const ROUTE_EDIT_PATIENT_CASE       = "EditPatientCase";

export const ROUTE_ARCHIVE_PATIENT_CASE       = "ArchiveCase";

export const ROOT_ROUTE_CASES              = "Cases";
export const ROUTE_NEW_PATIENT_CASE_INFO   = "NewPatientCaseInfo";

export const ROOT_ROUTE_SUBMISSIONS        = "Submissions";
export const ROUTE_SUBMISSION_CASES        = "SubmissionCases";
export const ROUTE_SUBMISSION_CENSUS       = "SubmissionCensus";
export const ROUTE_OPEN_CENSUS_PACKAGE       = "CreateSubmissions";

export const ROOT_ROUTE_REPORTS            = "Reports";
export const ROUTE_REPORT_SUMMARY          = "ReportSummary";
export const ROUTE_REPORT_TABLE            = "ReportTable";

export const ROOT_ROUTE_LOGIN              = "Login";

export const ROOT_ROUTE_ADMIN              = "Admin";
export const ROUTE_USERS                   = "Users";
export const ROUTE_ROLES                   = "Roles";
export const ROUTE_ADD_USER                = "AddUser";
export const ROUTE_EDIT_USER               = "EditUser";
export const ROUTE_EDIT_ROLE               = "EditRole";

export default {
  APP_ROOT,
  ROOT_ROUTE_CASES,
  ROOT_ROUTE_PATIENTS,
  ROUTE_PATIENT_PROFILE,
  ROUTE_PATIENT_PROFILE_PREVIEW,
  ROUTE_NEW_PATIENT_CASE_INFO,
  ROUTE_NEW_PATIENT,
  ROUTE_EDIT_PATIENT,
  ROUTE_NEW_PATIENT_CASE,
  ROUTE_ARCHIVE_PATIENT_CASE,
  ROUTE_PATIENT_INFO,
  ROUTE_EDIT_PATIENT_CASE,
  ROOT_ROUTE_SUBMISSIONS,
  ROUTE_SUBMISSION_CASES,
  ROUTE_SUBMISSION_CENSUS,
  ROUTE_OPEN_CENSUS_PACKAGE,
  ROOT_ROUTE_REPORTS,
  ROUTE_REPORT_SUMMARY,
  ROUTE_REPORT_TABLE,
  ROOT_ROUTE_LOGIN,
  ROOT_ROUTE_ADMIN,
  ROUTE_USERS,
  ROUTE_ROLES,
  ROUTE_ADD_USER,
  ROUTE_EDIT_USER,
  ROUTE_EDIT_ROLE
}
